import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper, { PageCard, PageTitle, SectionH2, Para } from '../../components/Layout/PageWrapper';

function PrivacyPolicy() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Privacy Policy |Car Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online</title>
        <meta name="description" content="Read theCar Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online privacy policy. Learn how we collect, use, and protect your information." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://cargames.site/privacy-policy" />
      </Helmet>
      <PageCard>
        <PageTitle>Privacy Policy</PageTitle>
        <SectionH2>Introduction</SectionH2>
        <Para>AtCar Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online, accessible from https://cargames.site/, one of our main priorities is the privacy of our visitors. This Privacy Policy outlines the types of information collected and how we use it.</Para>
        <Para>If you have additional questions or require more information, do not hesitate to contact us at info@cargames.com.</Para>
        <SectionH2>Consent</SectionH2>
        <Para>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</Para>
        <SectionH2>Information We Collect</SectionH2>
        <Para>We may collect personal information such as your name, email address, and usage data when you interact with our website.</Para>
        <Para>When you contact us directly, we may receive additional information including your name, email, and message contents.</Para>
        <SectionH2>How We Use Your Information</SectionH2>
        <Para>We use your information to provide and improve our services, respond to your messages, and send updates aboutCar Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online.</Para>
        <Para>We never sell your personal information to third parties.</Para>
        <SectionH2>Cookies</SectionH2>
        <Para>Car Games uses cookies to enhance your experience. You can choose to disable cookies through your browser settings, though this may affect some features.</Para>
        <Para>Third-party advertisers (Google AdSense) may also use cookies. Please refer to Google's Privacy Policy for more details.</Para>
        <SectionH2>Third Party Privacy Policies</SectionH2>
        <Para>Our Privacy Policy does not apply to third-party services. We advise you to review the Privacy Policies of third-party partners.</Para>
        <SectionH2>Children's Information</SectionH2>
        <Para>Car Games does not knowingly collect personal information from children under 13. If you believe your child has provided such information, please contact us immediately.</Para>
        <SectionH2>Changes to This Policy</SectionH2>
        <Para>We may update our Privacy Policy from time to time. We advise you to review this page periodically for any changes.</Para>
      </PageCard>
    </PageWrapper>
  );
}

export default PrivacyPolicy;
